import { useState } from "react";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderDTO } from "./BonificoOrderDTO.ts";

export function useRefundBonificoOrder() {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const refundOrder = async (
    orderId: string,
    amountToRefundInCents?: number,
  ): Promise<BonificoOrderDTO> => {
    setLoading(true);
    try {
      const { data } = await createAxiosInstance().post<BonificoOrderDTO>(
        `/bonifico-orders/${orderId}/refund`,
        {
          ...(amountToRefundInCents !== undefined && { amountToRefundInCents }),
        },
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return { refundOrder, loading };
}
